import { call, put, takeEvery } from "redux-saga/effects";
import store from "redux/store";
import {  toast } from 'react-toastify';
import { onLoaderTrigger } from "redux/actions/commonAction";
import { GET_CAR, GET_CARFACILTIES ,GET_ADDCAR_FAILED, GET_ADDCAR_REQUESTED, GET_ADDCAR_SUCCESS,GET_DELETECAR_FAILED, GET_DELETECAR_REQUESTED, GET_DELETECAR_SUCCESS, GET_FACILITIES_FAILED, GET_FACILITIES_REQUESTED, GET_FACILITIES_SUCCESS, GET_UPDATECAR_FAILED, GET_UPDATECAR_REQUESTED, GET_UPDATECAR_SUCCESS} from "resources/actionTypes";
import { carApi, carFacilities,addCarApi,deleteCarApi,updateCarApi,facilitiesApi } from "services/CarService";
import { getRateCard } from "redux/actions/UserRateCard";
import { getCar } from "redux/actions/UserCar";

function* fetchCar(action) {
   const payload = action.payload || {}
  if(!payload?.data?.loader){
  store.dispatch(onLoaderTrigger(true));
  }
  const userCar = yield call(carApi, payload?.data);
    if (userCar?.success) {
      yield put({ type: GET_CAR.GET_CAR_SUCCESS, userCar: userCar });

      if (payload?.type) {
        const payloadData = {
          ...payload?.data,
          carType: userCar?.data?.[0]?.id
        }

        const carType = userCar?.data?.map((val) => ({
          id: val.id,
          name: val.carType,
        }));

        const filterValues = {
          ...payload?.filterValues,
          carType: carType?.[0]
        }
        payload?.setFilterValues(filterValues)
        store.dispatch(getRateCard(payloadData))
      }

    } else {
      yield put({ type: GET_CAR.GET_CAR_FAILED, message: userCar?.message });
    }
    if(!payload?.data?.loader){
      store.dispatch(onLoaderTrigger(false));
    }

}

export function* carSaga() {
  yield takeEvery(GET_CAR.GET_CAR_REQUESTED, fetchCar);
}

function* fetchCarFacilities(action) {
  store.dispatch(onLoaderTrigger(true));
    const payload = action.payload || {}
    const userCarFacilities = yield call(carFacilities, payload?.data);

    if (userCarFacilities?.success) {
      yield put({ type: GET_CARFACILTIES.GET_CARFACILTIES_SUCCESS, userCarFacilities: userCarFacilities })
    } else {
      yield put({ type:GET_CARFACILTIES.GET_CARFACILTIES_FAILED, message: userCarFacilities?.message });
    }

    store.dispatch(onLoaderTrigger(false));

}

export function* carFacilitiesSaga() {
  yield takeEvery(GET_CARFACILTIES.GET_CARFACILTIES_REQUESTED, fetchCarFacilities);
}

function* fetchAddCar(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userAddCar = yield call(addCarApi, payload.userAddCar);
  if(userAddCar.success){
    yield put({ type: GET_ADDCAR_SUCCESS, userAddCar: userAddCar });
    toast.success(userAddCar.message);
    store.dispatch(getCar({loader:true}));
  }else{
    yield put({ type: GET_ADDCAR_FAILED, message: userAddCar.message });
      toast.error(userAddCar.message || 'Add Car failed');
  }
  store.dispatch(onLoaderTrigger(false));
}
export function* addCarSaga() {
  yield takeEvery(GET_ADDCAR_REQUESTED, fetchAddCar);

}

function* fetchUpdateCar(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userUpdateCar = yield call(updateCarApi, payload.userUpdateCar);
  if(userUpdateCar.success){
    yield put({ type: GET_UPDATECAR_SUCCESS, userUpdateCar: userUpdateCar });
    toast.success(userUpdateCar.message);
    store.dispatch(getCar({loader:true}));
    store.dispatch(onLoaderTrigger(false));
  
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_UPDATECAR_FAILED, message: userUpdateCar.message });
      toast.error(userUpdateCar.message || 'Update Car failed');
  }
}
export function* updateCarSaga() {
  yield takeEvery(GET_UPDATECAR_REQUESTED, fetchUpdateCar);
}

function* fetchDeleteCar(action) {
  const payload = action.payload || {}
  store.dispatch(onLoaderTrigger(true));
  const userDeleteCar = yield call(deleteCarApi, payload.userDeleteCar);
  if(userDeleteCar.success){
    yield put({ type: GET_DELETECAR_SUCCESS, userDeleteCar: userDeleteCar });
    toast.success(userDeleteCar.message);
    store.dispatch(onLoaderTrigger(false));
    store.dispatch(carApi());
  }else{
    store.dispatch(onLoaderTrigger(false));
    yield put({ type: GET_DELETECAR_FAILED, message: userDeleteCar.message });
      toast.error(userDeleteCar.message || 'Delete Car failed');
  }
}
export function* deleteCarSaga() {
  yield takeEvery(GET_DELETECAR_REQUESTED, fetchDeleteCar);
}

function* fetchFacilities(action) {
  try {
    const payload = action.payload || {}
    const userFacilities = yield call(facilitiesApi,payload?.id);
    yield put({ type: GET_FACILITIES_SUCCESS, userFacilities: userFacilities });
  } catch (e) {
    yield put({ type: GET_FACILITIES_FAILED, message: e.message });
    toast.error(e.message || 'Get Facilities Failed')
  }
}

export function* facilitiesSaga() {
  yield takeEvery(GET_FACILITIES_REQUESTED, fetchFacilities);
}